var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.87501 7.2334V8.41429L8.69844 8.35311C8.48328 8.27709 8.43988 8.24108 8.42027 8.21696C8.40825 8.20218 8.35001 8.12294 8.35001 7.8084C8.35001 7.44984 8.60897 7.2334 8.83334 7.2334H8.87501Z",
    fill: "#6D6D77",
    stroke: "#6D6D77"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.15 12.1921C12.15 12.7838 11.7083 13.2671 11.1667 13.2671H10.625V10.8838L11.4667 11.1755C11.8917 11.3255 12.15 11.4671 12.15 12.1921Z",
    fill: "#6D6D77"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4917 1.66699H6.50832C3.47499 1.66699 1.66666 3.47533 1.66666 6.50866V13.492C1.66666 16.5253 3.47499 18.3337 6.50832 18.3337H13.4917C16.525 18.3337 18.3333 16.5253 18.3333 13.492V6.50866C18.3333 3.47533 16.525 1.66699 13.4917 1.66699ZM11.8833 10.0003C12.5333 10.2253 13.4 10.7003 13.4 12.192C13.4 13.4753 12.4 14.517 11.1667 14.517H10.625V15.0003C10.625 15.342 10.3417 15.6253 9.99999 15.6253C9.65832 15.6253 9.37499 15.342 9.37499 15.0003V14.517H9.07499C7.70832 14.517 6.59999 13.3587 6.59999 11.942C6.59999 11.6003 6.87499 11.317 7.22499 11.317C7.56666 11.317 7.84999 11.6003 7.84999 11.942C7.84999 12.6753 8.39999 13.267 9.07499 13.267H9.37499V10.442L8.11666 10.0003C7.46666 9.77533 6.59999 9.30033 6.59999 7.80866C6.59999 6.52533 7.59999 5.48366 8.83332 5.48366H9.37499V5.00033C9.37499 4.65866 9.65832 4.37533 9.99999 4.37533C10.3417 4.37533 10.625 4.65866 10.625 5.00033V5.48366H10.925C12.2917 5.48366 13.4 6.64199 13.4 8.05866C13.4 8.40033 13.125 8.68366 12.775 8.68366C12.4333 8.68366 12.15 8.40033 12.15 8.05866C12.15 7.32533 11.6 6.73366 10.925 6.73366H10.625V9.55866L11.8833 10.0003Z",
    fill: "#6D6D77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.11c889de30822f928fb014aee42a56c5.svg";
export { ForwardRef as ReactComponent };